export namespace DeactivationReasonConstants {
  export const NO_SHOW = 'DNOSHOW';
  export const CANCELLED_AFTER_CUTOFF = 'DCANCEL';
  export const THREE_CANCELLATIONS_BEFORE_CUTOFF = 'D3CANCE';
  export const THREE_LATE_ARRIVALS = 'D3LATEA';
  export const CASH_SOLICITED = 'DSOLCSH';
  export const SOLICITED_OUTSIDE_TNC_APP = 'DSOLRID';
  export const UNPROFESSIONAL_ACTS = 'DUNPROF';
  export const DEACTIVATED_BY_TNC = 'DTNCDEA';
  export const RIDER_COMPLAINTS = 'DRIDCOM';
  export const VIOLATED_TOS = 'DVIOTOS';
  export const OTHER = 'OTHERNL';
  export const USER_REQUESTED = 'USERREQ';
  export const FRAUD_SCAM_DETECTED = 'FRAUDAL';
  export const BAD_INCORRECT_EMAIL_ADDRESS = 'BEMAIL';
  export const REQUIRED_DOCUMENTS_EXPIRING_EXPIRED = 'DOCEXP';
  export const REQUIRED_SIGNATURES_EXPIRING_EXPIRED = 'SIGEXP';
  export const REQUIRED_SCREENINGS_EXPIRING_EXPIRED = 'SCREXP';
  export const REQUIRED_CERTIFICATIONS_EXPIRING_EXPIRED = 'CERTEXP';
  export const NO_ACTIVITY = 'INACTV';
}
